var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td'),_c('td',{staticClass:"text-center"},[_c('p',{staticClass:"mb-2 font-weight-bolder"},[_vm._v(_vm._s(_vm.name))])]),_c('td',{attrs:{"colspan":"8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }